<script>
import appConfig from '@src/app.config'

export default {
  props: ['content', 'mls_field_values', 'lang'],
  components: {  },
  data() {
    return {

    }
  },
  computed: {
    isHidden: function() {
      if(this.content.Hidden) { return true; }
      if(this.content.Conditional && this.content.Conditional.constructor === Array) {
        for(var i in this.content.Conditional) {
          if(this.content.Conditional[i].action == 'hidden_if') {
            if(this.content.Conditional[i].condition == 'any_value') {
              if(this.mls_field_values[this.content.Conditional[i].field] && this.mls_field_values[this.content.Conditional[i].field].output) {
                return true;
              }
            } else if(this.content.Conditional[i].condition == 'emtpy') {
              if(!this.mls_field_values[this.content.Conditional[i].field] || (this.mls_field_values[this.content.Conditional[i].field] && !this.mls_field_values[this.content.Conditional[i].field].output)) {
                return true;
              }
            } else if(this.content.Conditional[i].condition == 'equal_to') {
              if(this.mls_field_values[this.content.Conditional[i].field] && this.mls_field_values[this.content.Conditional[i].field].output && this.content.Conditional[i].value && this.mls_field_values[this.content.Conditional[i].field].output.toLowerCase() == this.content.Conditional[i].value.toLowerCase()) {
                return true;
              }
            } else if(this.content.Conditional[i].condition == 'not_equal_to') {
              if(this.mls_field_values[this.content.Conditional[i].field] && this.mls_field_values[this.content.Conditional[i].field].output && this.content.Conditional[i].value && this.mls_field_values[this.content.Conditional[i].field].output.toLowerCase() == this.content.Conditional[i].value.toLowerCase()) { } else {
                return true;
              }
            }
          }
        }
      }
      return false;
    },
    isRequired: function() {
      if(this.content.Required) { return true; }
      if(this.content.Conditional && this.content.Conditional.constructor === Array) {
        for(var i in this.content.Conditional) {
          if(this.content.Conditional[i].action == 'require_if') {
            if(this.content.Conditional[i].condition == 'any_value') {
              if(this.mls_field_values[this.content.Conditional[i].field] && this.mls_field_values[this.content.Conditional[i].field].output) {
                return true;
              }
            } else if(this.content.Conditional[i].condition == 'emtpy') {
              if(!this.mls_field_values[this.content.Conditional[i].field] || (this.mls_field_values[this.content.Conditional[i].field] && !this.mls_field_values[this.content.Conditional[i].field].output)) {
                return true;
              }
            } else if(this.content.Conditional[i].condition == 'equal_to') {
              if(this.mls_field_values[this.content.Conditional[i].field] && this.mls_field_values[this.content.Conditional[i].field].output && this.content.Conditional[i].value && this.mls_field_values[this.content.Conditional[i].field].output.toLowerCase() == this.content.Conditional[i].value.toLowerCase()) {
                return true;
              }
            } else if(this.content.Conditional[i].condition == 'not_equal_to') {
              if(this.mls_field_values[this.content.Conditional[i].field] && this.mls_field_values[this.content.Conditional[i].field].output && this.content.Conditional[i].value && this.mls_field_values[this.content.Conditional[i].field].output.toLowerCase() == this.content.Conditional[i].value.toLowerCase()) { } else {
                return true;
              }
            }
          }
        }
      }
      return false;
    },
  },
  created() {
    // reso
    // custom
    // html
    // widget

    // "String" Text Input
    // "String List, Single" Select Dropdown, Single
    // "String List, Multi" Select Dropdown, Multi
    // "Textarea" Textarea
    // "Money" Money
    // "Number" Number
    // "Boolean" Checkbox
    // "Date" Date
    // "Date and time" Date and time
  },
  methods: {

  }
}
</script>


<template>

  <span class="">
    <div v-if="content.FieldType == 'html'" v-html="content.Default"></div>

    <div v-else-if="content.FieldType == 'reso' || content.FieldType == 'custom'">
      <div class="form-group mb-0">
        <label v-if="content.SimpleDataType != 'Boolean'" v-tippy @show="() => content.Definition || (content.Synonym && content.Synonym.length) ? true : false" :content="
          `<div class='text-left'>`+
          (content.Definition ? `<strong>Definition</strong><br>`+content.Definition : '')+
          (content.Definition && content.Synonym && content.Synonym.length ? `<br><br>` : ``)+
          (content.Synonym && content.Synonym.length ? `<strong>Synonym(s)</strong><br>`+content.Synonym.join(', ') : '')+
          `</div>`
          "><span v-if="isHidden" class="text-info" v-tippy content="Hidden">* </span><span v-if="isRequired" class="text-danger" v-tippy content="Required">* </span>{{lang || !content.SpanishStandardName ? content.Title : content.SpanishStandardName}}
          <i v-if="content.Definition || (content.Synonym && content.Synonym.length)" class="mdi mdi-information-outline text-muted"></i>
        </label>

        <div v-if="content.SimpleDataType == 'String List, Single'">
          <select class="form-control" v-model="mls_field_values[content.StandardName].output" :required="content.Required" :disabled="content.Disabled">
            <option value="">Select...</option>
            <option v-for="(option, option_i) in content.Options" :key="option_i" :value="option">{{option}}</option>
          </select>
        </div>

        <div v-else-if="content.SimpleDataType == 'String List, Multi'" :required="content.Required">
          <multiselect v-model="mls_field_values[content.StandardName].output" :options="content.Options" :taggable="false" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Select...">
          </multiselect>
        </div>

        <div v-else-if="content.SimpleDataType == 'Textarea'">
          <textarea class="form-control" rows="3" v-model="mls_field_values[content.StandardName].output" :required="content.Required" :disabled="content.Disabled" :maxlength="content.Max"></textarea>
          <div v-if="content.Max" class="small text-muted">Character limit : {{mls_field_values[content.StandardName].output.length}} / {{content.Max}}</div>
        </div>

        <div v-else-if="content.SimpleDataType == 'Money'">
          <w-money class="form-control" v-model="mls_field_values[content.StandardName].output" :required="content.Required" :disabled="content.Disabled"></w-money>
        </div>

        <div v-else-if="content.SimpleDataType == 'Number'">
          <input type="number" class="form-control" :min="content.Min ? content.Min : ''" :max="content.Max ? content.Max : ''" step="any" v-model="mls_field_values[content.StandardName].output" :required="content.Required" :disabled="content.Disabled">
        </div>

        <div v-else-if="content.SimpleDataType == 'Boolean'">
          <p-check class="p-default p-curve p-bigger p-smooth" color="success-o" v-model="mls_field_values[content.StandardName].output" true-value="Yes" :required="content.Required" :disabled="content.Disabled" v-tippy @show="() => content.Definition || (content.Synonym && content.Synonym.length) ? true : false" :content="
            `<div class='text-left'>`+
            (content.Definition ? `<strong>Definition</strong><br>`+content.Definition : '')+
            (content.Definition && content.Synonym && content.Synonym.length ? `<br><br>` : ``)+
            (content.Synonym && content.Synonym.length ? `<strong>Synonym(s)</strong><br>`+content.Synonym.join(', ') : '')+
            `</div>`
            ">{{lang || !content.SpanishStandardName ? content.Title : content.SpanishStandardName}} <i v-if="content.Definition || (content.Synonym && content.Synonym.length)" class="mdi mdi-information-outline text-muted"></i>
          </p-check>
        </div>

        <div v-else-if="content.SimpleDataType == 'Date'">
          <input type="date" class="form-control" v-model="mls_field_values[content.StandardName].output" :required="content.Required" :disabled="content.Disabled" :min="content.Min ? moment().add(content.Min, 'days').format('YYYY-MM-DD') : ''" :max="content.Max ? moment().add(content.Max, 'days').format('YYYY-MM-DD') : ''""></input>
        </div>

        <div v-else-if="content.SimpleDataType == 'Date and time'">
          <input type="datetime-local" class="form-control" v-model="mls_field_values[content.StandardName].output" :required="content.Required" :disabled="content.Disabled" :min="content.Min ? moment().add(content.Min, 'days').format('YYYY-MM-DDT00:00:00') : ''" :max="content.Max ? moment().add(content.Max, 'days').format('YYYY-MM-DDT00:00:00') : ''"></input>
        </div>

        <div v-else>
          <input type="text" class="form-control" v-model="mls_field_values[content.StandardName].output" :required="content.Required" :disabled="content.Disabled" :maxlength="content.Max"></input>
          <div v-if="content.Max" class="small text-muted">Character limit : {{mls_field_values[content.StandardName].output.length}} / {{content.Max}}</div>
        </div>

        <div v-if="content.Disabled" class="small text-muted">Input is marked as read only</div>

      </div>
    </div>
  </span>

</template>
